import { useCallback, useMemo } from "react"

import { EventLabelParams } from "../components/DataTracking/trackingContext"
import { useDataTracking } from "../hooks/useDataTracking"

export interface Event {
  category?: string
  action: string
  label: Omit<EventLabelParams, "search_text"> & {
    search_text?: string
  }
}

export const useSearchDataTrack = () => {
  const dataTracking = useDataTracking()

  const { dataTracker, computeEventLabel, query, activeTab } = dataTracking

  if (!dataTracker) throw new Error("dataTracker is undefined")
  if (!activeTab) throw new Error("activeTab is undefined")

  const fire = useCallback(
    (data: Event) => {
      const payload = {
        category: "UniversalSearch",
        ...data,
        label: computeEventLabel({
          search_text: query,
          ...data.label,
        }),
      }

      dataTracker.fire(
        {
          GA: true,
          Piwik: true,
        },
        payload,
      )

      /* istanbul ignore next */
      if (
        process.env.REACT_APP_ENV === "development" &&
        process.env.NODE_ENV !== "test"
      ) {
        const { label, ...rest } = payload
        console.debug({
          ...rest,
          label: JSON.parse(label),
        })
      }
    },
    [computeEventLabel, dataTracker, query],
  )

  const result = useMemo(
    () => ({
      ...dataTracking,
      activeTab,
      dataTracker,
      fire,
    }),
    [activeTab, dataTracker, dataTracking, fire],
  )

  return result
}
